/*
 *  -----------------------------------------------------------------------
 *    <copyright file="export-study-config/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent } from '@mui/material';

import { useTranslation } from 'hooks';
import { StudyFields } from 'queries/generated/fragments.generated';
import Button from 'views/components/core/buttons';
import { CustomDialog, DialogActions, DialogTitle } from 'views/components/core/dialog';

import './styles.scss';

const ExportStudyConfig = ({ open, onClose, study }: { open: boolean; onClose: Function; study: StudyFields }) => {
    const { t } = useTranslation();

    const close = (result?: boolean) => {
        onClose(result);
    };

    return (
        <CustomDialog
            onClose={() => {
                close();
            }}
            fullWidth
            maxWidth="md"
            scroll="paper"
            open={open}
            className="custom-width-popup"
        >
            <DialogTitle id="export-study-config-modal-title">
                {t('admin:exportStudy')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={() => {
                        close(false);
                    }}
                    data-testid="close-dialog"
                />
            </DialogTitle>
            <DialogContent className="export-study-dialog-content">
                <div className="export-study-text">{t('admin:areYouSureToExportStudy')}</div>
                <DialogActions className="flex-end export-study-actions">
                    <Button
                        id="export-study-btn"
                        text="export"
                        onClick={() => {
                            close(true);
                        }}
                    />
                </DialogActions>
            </DialogContent>
        </CustomDialog>
    );
};

export default ExportStudyConfig;
